//#region IMPORTS
import { InstoreTemplateTableRow } from "../../models/instoreTemplate";
import { useVirtualizer } from "@tanstack/react-virtual";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import { Row, Table } from "@tanstack/react-table";
import { RefObject } from "react";
import InstoreTemplateDetailTableBodyDragRow from "./InstoreTemplateDetailTableBodyDragRow";
//#endregion

//#region INTERFACE
interface Props {
  tableContainerRef: RefObject<HTMLDivElement>;
  moveRow: (toIndex: number, row: InstoreTemplateTableRow) => void;
  table: Table<InstoreTemplateTableRow>;
}
//#endregion

export default function InstoreTemplateDetailTableBody({
  tableContainerRef,
  moveRow,
  table,
}: Props) {
  //#region SETUP
  const { rows } = table.getRowModel();

  const rowVirtualizer = useVirtualizer<HTMLDivElement, HTMLTableRowElement>({
    getScrollElement: () => tableContainerRef.current,
    estimateSize: () => 40,
    count: rows.length,
    overscan: 5,
  });
  //#endregion

  //#region RENDER
  return (
    <DndProvider backend={HTML5Backend}>
      <tbody
        className="bg-white relative"
        style={{ height: `${rowVirtualizer.getTotalSize()}px` }}
      >
        {rowVirtualizer.getVirtualItems().map((virtualRow) => {
          const row = rows[virtualRow.index] as Row<InstoreTemplateTableRow>;
          return (
            <InstoreTemplateDetailTableBodyDragRow
              virtualRow={virtualRow}
              moveRow={moveRow}
              key={row.id}
              row={row}
            />
          );
        })}
      </tbody>
    </DndProvider>
  );
  //#endregion
}
